import { initSubRoutes } from '../../../../utils/router';

const RoutesAjouterEmploye = initSubRoutes({
    route: '/ajouter-employe/',
    subroutes: {},
    nom: 'Ajouter un employé',
});

export default RoutesAjouterEmploye;
